import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    ref: "editorRef",
    class: "editor",
    style: _normalizeStyle({ width: _ctx.width ? `${_ctx.width}px` : '100%' })
  }, null, 4))
}